export default __webpack_public_path__ + "static/media/clothing.835f9813.png";